var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCro1381AdultHotelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00171 3.94576C7.572 3.94576 7.20357 3.8017 6.89643 3.51358C6.58929 3.22545 6.43571 2.87908 6.43571 2.47449C6.43571 2.06988 6.58871 1.72298 6.89471 1.43378C7.20073 1.14459 7.56859 0.999989 7.99829 0.999989C8.428 0.999989 8.79643 1.14405 9.10357 1.43217C9.41071 1.7203 9.56429 2.06667 9.56429 2.47126C9.56429 2.87587 9.41129 3.22277 9.10529 3.51197C8.79927 3.80117 8.43141 3.94576 8.00171 3.94576ZM7.14286 17C6.96071 17 6.80804 16.942 6.68482 16.826C6.56161 16.7099 6.5 16.5662 6.5 16.3947V11.1488H5.64286C5.46071 11.1488 5.30804 11.0908 5.18482 10.9748C5.06161 10.8588 5 10.715 5 10.5435V6.10465C5 5.77174 5.12589 5.48675 5.37768 5.24967C5.62946 5.0126 5.93214 4.89406 6.28571 4.89406H9.71429C10.0679 4.89406 10.3705 5.0126 10.6223 5.24967C10.8741 5.48675 11 5.77174 11 6.10465V10.5435C11 10.715 10.9384 10.8588 10.8152 10.9748C10.692 11.0908 10.5393 11.1488 10.3571 11.1488H9.5V16.3947C9.5 16.5662 9.43839 16.7099 9.31518 16.826C9.19196 16.942 9.03929 17 8.85714 17H7.14286Z",
    fill: "#6E7983"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_1338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro1381AdultHotelIcon);
export default __webpack_public_path__ + "static/media/cro1381-adult-hotel-icon.d9bbdc48.svg";
export { ForwardRef as ReactComponent };